import { render } from "./InfoResults.vue?vue&type=template&id=a31b20a0"
import script from "./InfoResults.vue?vue&type=script&lang=js"
export * from "./InfoResults.vue?vue&type=script&lang=js"

import "./InfoResults.vue?vue&type=style&index=0&id=a31b20a0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__